/**
 * Ask the host page to switch the embed frame to its expanded size.
 *
 * The parent-page bridge (`inresi-embed-bridge`) answers `RESIZE` without a
 * `height` by reading the wrapper's own CSS: `expand: true` pins the frame to
 * the wrapper's `max-height`, `expand: false` to its `min-height`. The sizes
 * therefore live in the client's `.inresi-container` rules, not here.
 *
 * Idempotent — `expand` is an explicit boolean, not a toggle — so calling it
 * again once the frame is already expanded is a no-op on the host page.
 */
export function requestFrameExpand(): void {
  if (typeof window === "undefined") return;
  window.parent?.postMessage(
    { type: "RESIZE", payload: { expand: true } },
    "*"
  );
}
